import { useNavigate } from "react-router-dom";
import { UserNotificationsEnum } from "../../../../../app/pages/auth/userNotifications.enum";
import { SessionService } from "../../../../../app/base/services/session.service";

// to modify
export const useNotificationRedirect = () => {
    const navigate = useNavigate();

    const notificationRedirect = (code, entityId, workspaceID) => {
        // Admin Notifications redirects
        if(code === UserNotificationsEnum.AdminRegistration) {
            navigate(`/admin/request`);
            return;
        }else if(code === UserNotificationsEnum.AdminWorkspaceRequest) {
            navigate(`/admin/request?tab=2`)
            return;
        } else if(code === UserNotificationsEnum.AdminAssessmentRequest) {
            navigate(`/admin/request?tab=3`)
            return;
        } else if(code === UserNotificationsEnum.AdminExpertRequest) {
            navigate(`/admin/teams`)
            return;
        } else if(code === UserNotificationsEnum.AdminAddedTicket || code === UserNotificationsEnum.AdminAddedTicketMessage) {
            navigate(`/admin/help-desk/details/${entityId}`);
            return;
        }

        // NGO Notifications redirects
        else if(code === UserNotificationsEnum.NgoApprovedWorkspace) {
            SessionService.setItem('workspaceType', '1');
            navigate(`/workspace`)
            return;
        } else if(code === UserNotificationsEnum.NgoRejectedWorkspace) {
            SessionService.setItem('workspaceType', '2');
            navigate(`/workspace`)
            return;
        } else if(code === UserNotificationsEnum.NgoApprovedAssessment) {
            // SessionService.setItem('workspaceID', workspaceID);
            // navigate();
            return;
        } else if(code === UserNotificationsEnum.NgoRejectedAssessment) {
            // SessionService.setItem('workspaceID', workspaceID);
            // navigate();
            return;
        } else if(code === UserNotificationsEnum.NgoCompletedAssessment) {
            return;
        } else if(code === UserNotificationsEnum.NgoAddedTicketMessage) {
            SessionService.setItem('workspaceID', workspaceID);
            navigate(`/workspace/help-desk/details/${entityId}`);
            return;
        }



        else {
            return;
        }
    };

    return notificationRedirect
}